import { z } from "zod";

import { UserBase } from "@/data/users";

export const TimeReportHiringManager = UserBase.passthrough();

export type TimeReportHiringManager = z.infer<typeof TimeReportHiringManager>;
